import { Injectable } from '@angular/core';
import { FuseMockApiService } from '@fuse/lib/mock-api/mock-api.service';
import {
    campaignDetailsDataMap,
    campaignsData,
} from 'app/mock-api/apps/campaign/data';
import { cloneDeep } from 'lodash-es';

@Injectable({ providedIn: 'root' })
export class CampaignMockApi {
    private _campaigns: any[] = campaignsData;
    private _detailsMap: { [key: string]: any } = campaignDetailsDataMap;

    /**
     * Constructor
     */
    constructor(private _fuseMockApiService: FuseMockApiService) {
        this.registerHandlers();
    }

    /**
     * Register Mock API handlers
     */
    registerHandlers(): void {
        // GET Campaign List
        this._fuseMockApiService.onGet('api/apps/campaign/list').reply(() => {
            return [200, cloneDeep(this._campaigns)];
        });

        // GET Campaign Details by ID
        this._fuseMockApiService
            .onGet('api/apps/campaign/details')
            .reply(({ request }) => {
                const id = request.params.get('id') || 'c1';
                const details = this._detailsMap[id] || this._detailsMap['c1'];
                return [200, cloneDeep(details)];
            });

        // GET Leaderboard
        this._fuseMockApiService
            .onGet('api/apps/campaign/leaderboard')
            .reply(({ request }) => {
                const id = request.params.get('id') || 'c1';
                const details = this._detailsMap[id] || this._detailsMap['c1'];
                return [200, cloneDeep(details.leaderboard)];
            });

        // GET Not Complete Reload Members
        this._fuseMockApiService
            .onGet('api/apps/campaign/not-complete-reload')
            .reply(({ request }) => {
                const id = request.params.get('id') || 'c1';
                const details = this._detailsMap[id] || this._detailsMap['c1'];
                let members = cloneDeep(details.notCompleteReloadMembers);

                const search = request.params.get('search');
                if (search) {
                    const searchLower = search.toLowerCase();
                    members = members.filter(
                        (m: any) =>
                            m.memberId.toLowerCase().includes(searchLower) ||
                            m.name.toLowerCase().includes(searchLower) ||
                            m.phoneNumber.includes(searchLower)
                    );
                }

                return [200, members];
            });
    }
}
